import React, { FC, useState } from 'react'
import { findTarget } from '../../../../../../utils/microcopy.utils'
import { AllTabOrderWrapper } from '../style'

//* components
import GlobalContainer from '../../../../../global/globalContainer'
import SimpleNav from '../../../../../global/simpleNav'
import LeadershipBoard from '../../leadershipBoard'
import OfficeRegion from '../../officeRegion'

type Props = {
  listingPageData: any
}

export const OfficePageContent: FC<Props> = ({ listingPageData }) => {
  const [activeRegion, setActiveRegion] = useState(0)
  if (listingPageData.useCase !== 'Offices') return null

  let allButtons: { label: string }[] = []
  let totalOffices = 0

  if (listingPageData.tabOrder?.items) {
    allButtons = listingPageData.tabOrder.items.map((tab: any) => {
      totalOffices += tab.officeOrder ? tab.officeOrder?.length : 0

      return {
        label: `${tab.title}${tab.officeOrder ? `\u00A0(${tab.officeOrder.length})` : ''}`,
      }
    })

    if (listingPageData.microcopy?.values) {
      allButtons.unshift({
        label:
          findTarget(`AllTAB.text (${totalOffices})`, listingPageData.microcopy.values, false) ||
          `${listingPageData.microcopy.values[0].value} (${totalOffices})`,
      })
    }
  }

  return (
    <GlobalContainer>
      <SimpleNav
        activeButton={activeRegion}
        setActiveButton={setActiveRegion}
        allButtons={allButtons}
      />

      <AllTabOrderWrapper>
        {listingPageData.tabOrder?.items?.map((region: any, index: number) => {
          const officeRegionData = {
            ...region,
            microcopy: listingPageData.microcopy,
            index,
            activeRegion,
          }

          return <OfficeRegion key={`OfficeRegion_${index}`} {...officeRegionData} />
        })}
      </AllTabOrderWrapper>
    </GlobalContainer>
  )
}

export const LeadershipPageContent: FC<Props> = ({ listingPageData }) => {
  if (listingPageData.useCase !== 'Leadership') return null
  let leadershipBoardData = { ...listingPageData.tabOrder }

  if (listingPageData.microcopy?.values) {
    leadershipBoardData = { ...leadershipBoardData, microcopy: listingPageData.microcopy }
  }

  return (
    <GlobalContainer>
      <AllTabOrderWrapper>
        {listingPageData.tabOrder?.items && <LeadershipBoard {...leadershipBoardData} />}
      </AllTabOrderWrapper>
    </GlobalContainer>
  )
}
